import * as React from 'react'

export const ProjectFolder = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='-2 -5 27 27'
    xmlSpace='preserve'
    width="1em" height="1em" fill="currentColor"
  >
    <path d='M.72 17.64V1.72c.01-.16.04-.32.1-.45.22-.45.64-.71 1.14-.75h6c.55 0 .92.44 1.23.89.39.57.81 1.12 1.2 1.69.1.15.21.19.38.19 2.73-.01 5.46.01 8.19-.01.94-.01 1.71.59 1.66 1.65-.04.91-.01 2.89-.01 2.99.11 0 1.22.01 1.69 0 1.55-.02 2.51 1.48 1.78 2.89-1.24 2.37-2.42 4.77-3.57 7.17-.31.64-.68.87-1.4.87-5.57-.03-11.14-.01-16.71-.02-.28 0-.58-.06-.85-.16-.46-.17-.81-.51-.83-1.03zm1.79-.19c.06.01.08.01.11.01h16.43c.15 0 .2-.07.25-.18.54-1.09 1.08-2.17 1.62-3.26.65-1.31 1.31-2.62 1.96-3.94.19-.38.02-.69-.4-.76-.08-.01-.17-.02-.25-.02H6.86c-.38 0-.62.14-.79.5-1.05 2.26-2.11 4.52-3.17 6.78-.13.29-.26.57-.39.87zm-.4-2.53c.01 0 .02.01.04.01.03-.07.07-.13.1-.2.86-1.84 1.72-3.69 2.59-5.53.07-.16.15-.33.26-.48.44-.59 1.06-.8 1.78-.8h12.33V4.67h-8.53c-.58 0-1.03-.22-1.37-.7-.44-.62-.89-1.24-1.34-1.87-.09-.13-.19-.19-.35-.19-1.75.01-3.51 0-5.26 0-.08 0-.16.01-.25.01v13z' />
  </svg>
)
